import { useRef, useState } from 'react';

// HOOKS
import useOnClickOutside from '../../../hooks/useOnClickOutside';

// UTIL
import { isCardConsignee } from '../../../utils/consigneeRules';
import { numberFormat } from '../../../utils/Signature/formatCurrency';
import { dateFormat, daysRemainingUntilExpiration } from '../../../utils/Signature/formatDate';

// COMPONENT
import { IconTooltip, Tag } from '@bancobarigui/barihaus';
import { Checkbox } from '../../../components/UISignatue/Checkbox';
import { AngleUp, Calendar, Chart, Spreadsheet } from '../Form/svgs';

//STYLES
import {
  AccordionCard,
  AccordionContent,
  AccordionContentText,
  AccordionText,
  ActionCollapse,
  ContainerCardProposal,
  DescriptionContent,
  DescriptionValueProposal,
  FooterCardProposal,
  HeaderCardProposal,
  HeaderProposal,
  Icon,
  IconAccordion,
  Paragraph,
  SubParagraph,
  TextValueProposal,
  TitleCardProposal,
  ValidationDateContainer,
  ValueProposal,
} from './styles';

export const ProposalConsig = ({ formValues, handleClick, isChecked, id }: any) => {
  const releasedValue = formValues.commercialConditions.releasedValue;
  const showNetWithdrawal =
    isCardConsignee(formValues.cnpjConsigneeId) && Number.isSafeInteger(releasedValue) && releasedValue > 0;

  const content = useRef<HTMLInputElement>(null);
  const sensitive = useRef<HTMLInputElement>(null);
  const [rotation, setRotation] = useState('accordion__icon');
  const [active, setActive] = useState('');
  const [height, setHeight] = useState('0px');
  const [accordionTitle, setaccordionTitle] = useState('Ver detalhes');

  const toggleAccordion = () => {
    setActive(active === '' ? 'active' : '');
    setHeight(active === 'active' ? '0px' : `${content.current?.scrollHeight}px`);
    setRotation(active === 'active' ? 'accordion__icon' : 'accordion__icon rotate');
    setaccordionTitle(active === 'active' ? 'Ver detalhes' : 'Ocultar detalhes');
  };

  useOnClickOutside(sensitive, () => {
    setActive('');
    setHeight('0px');
    setRotation('accordion__icon');
    setaccordionTitle('Ver detalhes');
  });

  const daysRemaining = daysRemainingUntilExpiration(formValues.expirationDate);

  const getTagType = () => {
    if (daysRemaining === 1) return 'danger';
    if (daysRemaining > 1) return 'warning';
    return 'default';
  };

  return (
    <ContainerCardProposal className={'accordion__section, ' + (isChecked ? 'selected' : '')} ref={sensitive}>
      <HeaderCardProposal>
        <HeaderProposal>
          <Icon>
            <Spreadsheet />
          </Icon>
          <TitleCardProposal>Proposta {formValues.proposalNumber.slice(0, 5)}</TitleCardProposal>
        </HeaderProposal>
        {daysRemaining < 8 && (
          <Tag tagType={getTagType()} style={{ justifySelf: 'flex-end', marginInlineEnd: '0' }}>
            {daysRemaining === 0 ? 'Expirado' : `Expira em ${daysRemaining} dia${daysRemaining > 1 ? 's' : ''}`}
          </Tag>
        )}
      </HeaderCardProposal>
      <DescriptionContent>
        <DescriptionValueProposal>
          <TextValueProposal>Valor líquido do empréstimo</TextValueProposal>
          <ValueProposal>{numberFormat(formValues.commercialConditions.releasedValue / 100)}</ValueProposal>
        </DescriptionValueProposal>
        <DescriptionValueProposal>
          <TextValueProposal>Valor da parcela</TextValueProposal>
          <ValueProposal>{numberFormat(formValues.commercialConditions.installmentValue / 100)}</ValueProposal>
        </DescriptionValueProposal>
        {formValues.loanDetails[0].purchaseLimit > 0 && (
          <DescriptionValueProposal>
            <TextValueProposal>Valor do limite para compras</TextValueProposal>
            <ValueProposal>{numberFormat(formValues.loanDetails[0].purchaseLimit / 100)}</ValueProposal>
          </DescriptionValueProposal>
        )}
        {formValues?.commercialConditions?.remainingValue > 0 && (
          <DescriptionValueProposal>
            <TextValueProposal>Valor restante do benefício mensal</TextValueProposal>
            <ValueProposal>{numberFormat(formValues.commercialConditions.remainingValue / 100)}</ValueProposal>
          </DescriptionValueProposal>
        )}
        {formValues.expirationDate && (
          <DescriptionValueProposal>
            <ValidationDateContainer>
              <TextValueProposal>Data de vencimento</TextValueProposal>
              <IconTooltip
                tooltipType="info"
                title="Esta proposta é válida por 2 a 60 dias a partir da data de emissão. Após o vencimento, será expirada automaticamente"
              />
            </ValidationDateContainer>
            <ValueProposal>{dateFormat(formValues.expirationDate)}</ValueProposal>
          </DescriptionValueProposal>
        )}
      </DescriptionContent>
      <AccordionContent ref={content} style={{ maxHeight: `${height}` }} className="accordion__content">
        <AccordionCard>
          <IconAccordion>
            <Calendar />
          </IconAccordion>
          <AccordionContentText>
            <AccordionText>
              <Paragraph>Valor total do empréstimo</Paragraph>
              <SubParagraph>{numberFormat(formValues.commercialConditions.requestedValue / 100)}</SubParagraph>
            </AccordionText>
            {showNetWithdrawal && (
              <AccordionText>
                <Paragraph>Valor do Saque</Paragraph>
                <SubParagraph>{numberFormat(releasedValue / 100)}</SubParagraph>
              </AccordionText>
            )}
            <AccordionText>
              <Paragraph>IOF</Paragraph>
              <SubParagraph>{numberFormat(formValues.commercialConditions.iofValue / 100)}</SubParagraph>
            </AccordionText>
          </AccordionContentText>
        </AccordionCard>
        <AccordionCard>
          <IconAccordion>
            <Calendar />
          </IconAccordion>
          <AccordionContentText>
            <AccordionText>
              <Paragraph>Prazo do contrato</Paragraph>
              <SubParagraph>{formValues.commercialConditions.deadLine} meses</SubParagraph>
            </AccordionText>
          </AccordionContentText>
        </AccordionCard>
        <AccordionCard>
          <IconAccordion>
            <Chart />
          </IconAccordion>
          <AccordionContentText>
            <AccordionText>
              <Paragraph>Taxa de Juros mensal nominal</Paragraph>
              <SubParagraph>{formValues.commercialConditions.monthlyFee / 100}% ao mês</SubParagraph>
            </AccordionText>
            <AccordionText>
              <Paragraph>Taxa de Juros anual nominal</Paragraph>
              <SubParagraph>{formValues.commercialConditions.annualFee / 100}% ao ano</SubParagraph>
            </AccordionText>
            <AccordionText>
              <Paragraph>Custo Efetivo Total (CET) mensal</Paragraph>
              <SubParagraph>{formValues.commercialConditions.monthlyCet / 100}% ao mês</SubParagraph>
            </AccordionText>
            <AccordionText>
              <Paragraph>Custo Efetivo Total (CET) anual</Paragraph>
              <SubParagraph>{formValues.commercialConditions.annualCet / 100}% ao ano</SubParagraph>
            </AccordionText>
          </AccordionContentText>
        </AccordionCard>
        <AccordionCard>
          <IconAccordion>
            <Calendar />
          </IconAccordion>
          <AccordionContentText>
            <AccordionText>
              <Paragraph>Primeiro vencimento</Paragraph>
              <SubParagraph>{dateFormat(formValues.commercialConditions.dueDate)}</SubParagraph>
            </AccordionText>
          </AccordionContentText>
        </AccordionCard>
      </AccordionContent>
      <FooterCardProposal>
        <Checkbox
          id={id}
          type="checkbox"
          name={formValues.name}
          handleClick={handleClick}
          isChecked={isChecked}
          title={'Selecione para assinar'}
          termId={formValues.benefitCardTermId}
        />
        <ActionCollapse className={`add-margin ${rotation}`} onClick={toggleAccordion}>
          <AngleUp />
          {accordionTitle}
        </ActionCollapse>
      </FooterCardProposal>
    </ContainerCardProposal>
  );
};
